import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '.';
import { InputsReducerTypes } from '../types';
import phoneNumberFormatter from '../functions/phoneNumberFormatter';

const initialState: InputsReducerTypes = {
  firstName: '',
  lastName: '',
  zipCode: '',
  email: '',
  preferredContactMethod: 'email',
  preferredContactTime: '',
  phoneNumber: '',
  topicOfInterest: '',
  ccpa: false,
  universalConsent: false,
  dealerConsent: false,
  oemConsent: false,
  tradeInVehicleMake: '',
  tradeInVehicleModel: '',
  tradeInVehicleYear: '',
  tradeInVehicleMileage: '',
  tradeInVehicleTrimLine: '',
  tradeInVehicleVin: '',
  modelFamilyOfInterest: '',
  modelLineOfInterest: '',
};

const inputsSlice = createSlice({
  name: 'inputs',
  initialState,
  reducers: {
    setUserInputs: (state, action) => {
      const { inputName, inputValue } = action.payload;
      if (inputName === 'phoneNumber' && state.phoneNumber?.length < inputValue?.length) {
        return { ...state, phoneNumber: phoneNumberFormatter(inputValue) };
      }
      return { ...state, [inputName]: inputValue };
    },
  },
});

export const selectInputs = (state: RootState) => state.userInputs;

export const { setUserInputs } = inputsSlice.actions;

export default inputsSlice.reducer;
